/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from 'react';

class RadioButtonLayer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date()
        };
    }
    componentDidMount() {

    }
    onChange(evt) {
        console.log('radio-button',this.props.selectdata.title, evt.target.checked)
        this
            .props
            .onselectChanges({ id: this.props.selectdata.id, name: this.props.selectdata.name,value: this.props.selectdata.name, parrentMode: this.props.selectdata.table+this.props.selectdata.pid, parrentName: this.props.selectdata.table+this.props.selectdata.pid, parentID: this.props.selectdata.pid, tableName: this.props.selectdata.table });
    };

    render() {
        let{selectdata}= this.props;
        return (<div className={this.props.selectdata.name==='non-covid'||this.props.selectdata.name==='covid-ip'||this.props.selectdata.name==='covid-daycare'||this.props.selectdata.name==='covid-icu' ?'':"d-inline-flex"}>
            <input type="radio" 
            id={this.props.selectdata.title+this.props.selectdata.table+this.props.selectdata.pid} 
            name={this.props.selectdata.table+this.props.selectdata.pid} 
            value=""
            checked={this.props.selectdata.value ? true : false}
            onChange={evt => this.onChange(evt)}
            disabled={this.props.selectdata.disable} />
            <label for={this.props.selectdata.title+this.props.selectdata.table+this.props.selectdata.pid} className={selectdata.name==='non-covid'||this.props.selectdata.name==='covid-ip'||this.props.selectdata.name==='covid-daycare'||this.props.selectdata.name==='covid-icu'?"text-center ml-1":"text-center"}>{this.props.selectdata.title}</label>
        </div>);
    }
}

export default RadioButtonLayer;